import React from 'react';
import { Reveal } from '@/components/Reveal';

export const SectionHeading = ({
  eyebrow,
  title,
  intro,
  align = 'left',
  light = false,
  className = '',
  eyebrowClassName = '',
}) => {
  const alignCls = align === 'center' ? 'text-center mx-auto items-center' : 'text-left items-start';
  return (
    <div className={`flex flex-col ${alignCls} ${align === 'center' ? 'max-w-3xl' : 'max-w-2xl'} ${className}`}>
      {eyebrow && (
        <Reveal>
          <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`}>
            <span className='h-px w-8 bg-[#B88A3B]' />
            <span className={`eyebrow ${light ? 'text-[#B88A3B]' : 'text-[#075B61]'} ${eyebrowClassName}`}>{eyebrow}</span>
          </div>
        </Reveal>
      )}
      {title && (
        <Reveal delay={0.05}>
          <h2
            className={`mt-4 font-head text-3xl sm:text-4xl lg:text-[2.9rem] font-semibold leading-[1.08] tracking-[-0.02em] ${
              light ? 'text-[#F6F5F1]' : 'text-[#20272A]'
            }`}
          >
            {title}
          </h2>
        </Reveal>
      )}
      {intro && (
        <Reveal delay={0.1}>
          <p className={`mt-5 text-base leading-relaxed ${light ? 'text-[#F6F5F1]/70' : 'text-[#20272A]/70'}`}>{intro}</p>
        </Reveal>
      )}
    </div>
  );
};
